import * as React from "react";
import { Col } from "@lunchboxinc/lunchbox-components";
import { Condition } from "components/elements";
import {
  Tabs,
  Card as CardComps,
  Loader,
  Image,
  Footer,
} from "components/fragments";
import { LocationList, RestaurantsFilter } from "components/templates";
import { Text, View } from "components/elementsThemed";
import { withTemplate } from "components/hocs";
import { config, Copy, Routes, images } from "utils";
import LocationsMap from "../locationsMap";
import css from "./locationType3.module.scss";

const { Card, CardBody } = CardComps;

const { Condition: If } = Condition;

const Locations = ({
  clearLocations,
  deliveryChange,
  deliveryFetchCount,
  diningOption,
  fetching,
  filteredLocations,
  getGeo,
  getPickupGeo,
  googleMapKey,
  handleStreetChange,
  history,
  isMarketPlace,
  locationCardRefs,
  locations,
  locationState,
  locationTitle,
  onClickMarker,
  onTabChange,
  restaurants,
  selectedRestaurants,
  setSelectedRestaurants,
  style: { labels, cells, segmentViews, views },
  tabOrder,
  onLocationSelected,
}) => {
  const { address, lat, long } = locationState;

  const displayRestaurantFilter =
    isMarketPlace && config?.theme?.location?.restaurant_filter;

  const locationSection = () => {
    if (fetching) {
      return (
        <div className={css.loader}>
          <Loader />
        </div>
      );
    }
    if (locations.length) {
      return (
        <LocationList
          diningOption={diningOption}
          locations={filteredLocations}
          type={cells.primary}
          refs={(id, ref) => {
            const locationCardRefsTemp = { ...locationCardRefs };
            locationCardRefsTemp.current[id] = ref;
          }}
          onClick={onLocationSelected}
        />
      );
    }
    if (diningOption === "delivery") {
      return (
        <div className={css.nothing}>
          <Text type={labels.secondary}>
            <If is={!deliveryFetchCount.current}>
              <span className={css["static-text"]}>
                {Copy.LOCATIONS_STATIC.SEARCH_DELIVER_LOCATIONS_MESSAGE}
              </span>
              <If condition={config?.theme?.location?.search_image}>
                <Image
                  className={css["nothing--image"]}
                  src={images?.art_search}
                  alt="Search for Locations"
                />
              </If>
            </If>

            <If is={deliveryFetchCount.current}>
              <span className={css["static-text"]}>
                {Copy.LOCATIONS_STATIC.NO_LOCATIONS_TO_DELIVER_MESSAGE}
              </span>
              <Image
                className={css["nothing--image"]}
                src={images?.art_empty_locations}
                alt="No Locations Found"
              />
            </If>
          </Text>
          <If is={deliveryFetchCount.current}>
            <Text type={labels.secondary}>
              {Copy.LOCATIONS_STATIC.PICK_UP_SUGGESTION_MESSAGE}
            </Text>
          </If>
        </div>
      );
    }
    return null;
  };
  return (
    <div className={css.location}>
      <Col className={css["location-container"]} xs="1" sm="1-2" lg="1-3">
        <Card className={css["location-container--header"]}>
          <CardBody bordered={false} className={css.body}>
            <Text
              role="heading"
              aria-level="1"
              aria-label={locationTitle}
              className={css["body-title"]}
              type={labels.primary}
            >
              {locationTitle}
            </Text>
          </CardBody>
          <CardBody className={css.tabs}>
            <Tabs
              destroyInactiveTabPane
              type={segmentViews.standard}
              activeKey={diningOption}
              onTabChange={onTabChange}
            >
              {tabOrder.map((option) => (
                <div key={option.diningOption} title={option.name}>
                  <Col xs="1" className={css["tabs-container"]}>
                    {option.form({
                      address,
                      clearLocations,
                      deliveryChange,
                      getGeo,
                      getPickupGeo,
                      handleStreetChange,
                    })}
                  </Col>
                </div>
              ))}
            </Tabs>
          </CardBody>
        </Card>
        <View
          type={views.background}
          className={css["location-container--cards"]}
        >
          {displayRestaurantFilter && (
            <RestaurantsFilter
              type={cells.primary}
              restaurants={restaurants}
              selectedItems={selectedRestaurants}
              setSelectedItems={setSelectedRestaurants}
            />
          )}
          {locationSection()}
        </View>
        <Footer
          page="location"
          className={css["location-container--footer"]}
          type={cells.footer}
          style={{ maxWidth: "100%" }}
        />
      </Col>
      <Col
        className={css["location-map"]}
        xs={{ hidden: true, span: "1" }}
        sm="2-2"
        lg="3-3"
      >
        <LocationsMap
          type={cells.secondary}
          locations={locations}
          googleMapKey={googleMapKey}
          center={{ lat, lng: long }}
          onClickMarker={onClickMarker}
          googleMapURL={Routes.GOOGLE_MAP(googleMapKey)}
          loadingElement={<div style={{ height: "100%" }} />}
          containerElement={<div style={{ height: "100%" }} />}
          mapElement={<div style={{ height: "100%" }} />}
          diningOption={diningOption}
          history={history}
          isMarketPlace={isMarketPlace}
        />
      </Col>
    </div>
  );
};
export default withTemplate(Locations, "location");
